export default "__VITE_ASSET__337ce221__"